/* Wellsons vanity builder: reads the step config that snippets/ws-builder.liquid builds from the
   product's "Vanity builder" template (Shopify admin > Content > Metaobjects). */
(function () {
  var root = document.getElementById('WsVb'); if (!root || root.dataset.ready) return; root.dataset.ready = '1';
  var card = document.getElementById('WsVbCard');
  var CFG;
  try { CFG = JSON.parse(root.querySelector('[data-vb-cfg]').textContent); } catch (e) { if (window.console) console.warn('[ws-builder] bad config', e); return; }
  document.body.classList.add('ws-vb-on');
  if (!document.getElementById('ws-vb-more-css')) { var css = document.createElement('style'); css.id = 'ws-vb-more-css'; css.textContent = '.ws-vb__more{display:inline-flex;align-items:center;gap:4px;margin:12px 0 0;padding:9px 16px;border:1.5px solid #cfd8df;border-radius:999px;background:#fff;font:inherit;font-size:13.5px;font-weight:700;color:#245272;cursor:pointer}.ws-vb__more:hover{border-color:#35749f;background:#eaf2f8}'; document.head.appendChild(css); }

  // Move the full builder below the main product section (full width)
  var host = card && card.closest('[id^="shopify-section-"]');
  if (host && host.parentNode) host.parentNode.insertBefore(root, host.nextSibling);
  // Put the "Design your vanity" card where the old Infinite Options intro box was (right column)
  var osb = document.querySelector('.option-set-btn-container');
  if (card && osb && osb.parentNode) osb.parentNode.insertBefore(card, osb);

  var TITLE = root.dataset.title;
  if (CFG.title) root.querySelector('[data-vb-title]').textContent = CFG.title;
  var S = {}; // selections by step key
  var qty = 1;

  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // ---- size / bowl from product variants ("600mm - Centre Bowl")
  var MAIN = (CFG.main || []).map(function (v) {
    var parts = v.t.split(' - '); return { id: v.id, w: parts[0], b: parts.slice(1).join(' - ') || '', p: v.p, c: v.c, a: v.a, img: v.img, t: v.t };
  });
  var WIDTHS = []; MAIN.forEach(function (m) { if (WIDTHS.indexOf(m.w) < 0) WIDTHS.push(m.w); });
  var HAS_BOWL = MAIN.some(function (m) { return m.b; });
  var selW = null;
  function mainSel() { return MAIN.filter(function (m) { return m.id === S.size; })[0] || null; }
  function bowls() { var m = mainSel(); return m && /double/i.test(m.t) ? 2 : 1; }

  // ---- normalise the admin-built steps
  var NOISE = /\b(above[- ]counter|counter[- ]top|semi[- ]?inset|solid surface|wall[- ]hung|basin|vanity)\b/gi;
  function cleanModel(pt, vd) {
    var m = String(pt || '');
    if (vd && m.toLowerCase().indexOf(vd.toLowerCase() + ' ') === 0) m = m.slice(vd.length + 1);
    m = m.split(' - ')[0].replace(NOISE, ' ').replace(/\s+/g, ' ').trim();
    var prev; do { prev = m; m = m.replace(/\s+(white|matte|gloss)$/i, ''); } while (m !== prev && m.indexOf(' ') > 0);
    return m || String(pt || '');
  }
  function norm(o, tab) {
    var x = { v: o.v || 0, p: o.p || 0, c: o.c || 0, a: o.a !== false, img: o.img || '', tab: tab || '' };
    if (o.pt != null) { // add-on product variant
      var fin = o.vt && o.vt !== 'Default Title' ? o.vt : '';
      x.model = cleanModel(o.pt, o.vd);
      x.fin = fin || (o.pt.split(' - ')[1] || '').trim();
      x.n = o.pt + (fin ? ' – ' + fin : '');
    } else { // swatch
      x.n = o.n;
      if (o.g) { x.model = o.g; x.fin = o.n.replace(new RegExp('^' + o.g.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*[–—:-]?\\s*', 'i'), '') || o.n; }
      else { x.model = o.n; x.fin = ''; }
    }
    x.bn = x.fin ? x.model + ' – ' + x.fin : x.model; // basin label
    return x;
  }
  var steps = [];
  if (MAIN.length > 1) steps.push({ k: 'size', t: HAS_BOWL ? 'Size & bowl position' : 'Size', req: 1, p: 'Size' });
  (CFG.steps || []).forEach(function (st) {
    var s = { k: st.k, t: st.t, p: st.p || st.t, req: st.req, none: st.none, multi: st.multi, bowls: st.bowls, basin: st.basin, note: st.note, groups: [], o: [] };
    (st.groups || []).forEach(function (g) {
      var grp = { tab: g.tab || '', idx: [] };
      (g.o || []).forEach(function (o) { var x = norm(o, g.tab); grp.idx.push(s.o.length); s.o.push(x); });
      if (grp.idx.length) s.groups.push(grp);
    });
    if (s.o.length) steps.push(s); // a step with nothing live in it is skipped
  });
  // ---- size-matched options: an option whose name ends in a width ("... 1200mm") only shows for that vanity width
  var WNUM = MAIN.map(function (m) { return parseInt(m.w, 10) || 0; });
  function mmList(t) { var re = /(\d{3,4})\s?mm\b/gi, m, r = []; while ((m = re.exec(t || ''))) { var n = +m[1]; if (n >= 400 && n <= 3600) r.push(n); } return r; }
  function optW(o) { var t = o.n.split(/\bnot\s+(?:suitable\s+)?for\b/i)[0], r = mmList(t); return r.length ? r[r.length - 1] : 0; }
  function optEx(o) { var p = o.n.split(/\bnot\s+(?:suitable\s+)?for\b/i), r = [], re = /(\d{3,4})\s?mm\b(\s*double)?/gi, m; if (p.length < 2) return r; var t = p.slice(1).join(' '); while ((m = re.exec(t))) r.push({ w: +m[1], d: !!m[2] }); return r; }
  function excl(o, w) { return !!w && (o.ex || []).some(function (e) { return e.w === w && (!e.d || bowls() > 1); }); }
  function baseName(o) { return o.n.replace(/\s*[-–]?\s*\d{3,4}\s?mm\b/gi, ' ').replace(/\s+/g, ' ').trim().toLowerCase(); }
  steps.forEach(function (st) {
    if (st.k === 'size') return;
    st.o.forEach(function (o) { o.w = optW(o); o.ex = optEx(o); o.base = baseName(o); });
    st.sized = st.o.filter(function (o) { return o.w && WNUM.indexOf(o.w) > -1; }).length >= 2;
    st.onlyW = /\bonly\b/i.test(st.note || '') ? mmList(st.note) : [];
  });
  function selWidth() { var m = mainSel(); return m ? parseInt(m.w, 10) || 0 : 0; }
  function vis(st, i) { var o = st.o[i], w = selWidth(); if (!o) return true; if (excl(o, w)) return false; if (!st.sized || !o.w) return true; return !!w && o.w === w; }
  function live(st) { if (st.k === 'size') return true; var w = selWidth(); if (!w) return true; if (st.onlyW && st.onlyW.length && st.onlyW.indexOf(w) < 0) return false; return st.o.some(function (o, i) { return vis(st, i); }); }
  function liveSteps() { return steps.filter(live); }
  // keep picks on the matching width when the size changes (same item, new width), otherwise clear them
  function fixSized() {
    steps.forEach(function (st) {
      if (st.k === 'size') return;
      if (!live(st)) { delete S[st.k]; return; }
      var move = function (i) { if (i == null || i < 0 || vis(st, i)) return i; var b = st.o[i].base; for (var j = 0; j < st.o.length; j++) if (st.o[j].base === b && vis(st, j)) return j; return null; };
      if (st.multi) { if (S[st.k]) S[st.k] = S[st.k].map(move).filter(function (i) { return i != null; }); }
      else if (S[st.k] != null) { var n = move(S[st.k]); if (n == null) delete S[st.k]; else S[st.k] = n; }
    });
  }
  // ---- "Show more": long lists show about three rows until opened
  var OPEN = {};
  function lim(basin) { var w = window.innerWidth || 1200; return basin ? (w <= 960 ? 4 : 6) : (w <= 480 ? 6 : w <= 960 ? 9 : 18); }
  function moreBtn(key, total, open) {
    return '<button type="button" class="ws-vb__more" data-more="' + esc(key) + '">' + (open ? 'Show fewer' : 'Show all ' + total + ' options') + '<span aria-hidden="true">' + (open ? ' &#9652;' : ' &#9662;') + '</span></button>';
  }
  if (!steps.length) return;

  function optLabel(st, o) { return st.basin ? o.bn : o.n; }
  function qtyFor(st) { return st.bowls ? bowls() : 1; }
  function stepDone(st) { if (st.k === 'size') return !!S.size; var v = S[st.k]; return st.multi ? true : v != null; }
  function reqSteps() { return liveSteps().filter(function (s) { return s.req; }); }
  function doneReq() { return reqSteps().filter(stepDone).length; }
  function stepBy(k) { return steps.filter(function (s) { return s.k === k; })[0]; }

  // ---- pricing
  function lines() {
    var out = [], m = mainSel();
    if (m) out.push({ label: TITLE, sub: m.t, p: m.p, c: m.c, q: 1, main: true });
    liveSteps().forEach(function (st) {
      if (st.k === 'size') return;
      var v = S[st.k]; if (v == null || v === -1) return;
      (st.multi ? v : [v]).forEach(function (i) {
        var o = st.o[i]; if (!o) return;
        out.push({ step: st, label: st.t, sub: optLabel(st, o), vid: o.v || null, p: o.v ? o.p : 0, c: o.v ? o.c : 0, q: o.v ? qtyFor(st) : 1, a: o.a });
      });
    });
    return out;
  }
  function total() { return lines().reduce(function (a, l) { return a + l.p * l.q; }, 0) * qty; }
  function savings() { return lines().reduce(function (a, l) { return a + (l.c > l.p ? (l.c - l.p) * l.q : 0); }, 0) * qty; }

  // ---- render steps
  var stepsEl = root.querySelector('[data-vb-steps]');
  function stepHead(st, n) {
    var v = summaryText(st);
    return '<div class="ws-vb__sh"><span class="ws-vb__num">' + n + '</span><div class="ws-vb__sht"><h3>' + esc(st.t) + '</h3>' +
      '<span class="ws-vb__pill' + (st.req ? ' is-req' : '') + '">' + (st.req ? 'Required' : 'Optional') + '</span>' +
      (v ? '<span class="ws-vb__picked">&#10003; ' + esc(v) + '</span>' : '') + '</div></div>';
  }
  function summaryText(st) {
    if (st.k === 'size') { var m = mainSel(); return m ? m.t : ''; }
    var v = S[st.k]; if (v == null) return '';
    if (v === -1) return st.none;
    if (st.multi) return v.length ? v.map(function (i) { return st.o[i] ? optLabel(st, st.o[i]) : ''; }).filter(Boolean).join(', ') : '';
    return st.o[v] ? optLabel(st, st.o[v]) : '';
  }
  function priceTag(o, q) {
    if (!o.v) return '<span class="ws-vb__inc">Included</span>';
    return '<span class="ws-vb__add">+' + money(o.p * (q || 1)) + (q > 1 ? ' <small>(' + q + ' × ' + money(o.p) + ')</small>' : '') + '</span>' + (o.c > o.p ? ' <s>' + money(o.c * (q || 1)) + '</s>' : '');
  }
  function renderSize() {
    var h = '<div class="ws-vb__lbl">Width</div><div class="ws-vb__chips">' + WIDTHS.map(function (w) {
      return '<button type="button" class="ws-vb__chip' + (selW === w ? ' is-on' : '') + '" data-w="' + esc(w) + '">' + esc(w) + '</button>';
    }).join('') + '</div>';
    if (selW && HAS_BOWL) {
      h += '<div class="ws-vb__lbl">Bowl position</div><div class="ws-vb__cards ws-vb__cards--bowl">' + MAIN.filter(function (m) { return m.w === selW; }).map(function (m) {
        var on = S.size === m.id;
        return '<button type="button" class="ws-vb__card' + (on ? ' is-on' : '') + (m.a ? '' : ' is-na') + '" data-size="' + m.id + '"' + (m.a ? '' : ' disabled') + '>' +
          '<span class="ws-vb__bowl" data-bowl="' + esc(bowlKey(m.b)) + '"><i></i><i></i></span><b>' + esc(m.b || m.t) + '</b>' +
          '<span class="ws-vb__price">' + money(m.p) + (m.c > m.p ? ' <s>' + money(m.c) + '</s>' : '') + '</span>' + (m.a ? '' : '<em>Unavailable</em>') + '</button>';
      }).join('') + '</div>';
    } else if (!selW) {
      h += '<p class="ws-vb__hint">' + (HAS_BOWL ? 'Choose a width to see the bowl options.' : 'Choose a width.') + '</p>';
    }
    return h;
  }
  function bowlKey(b) { b = (b || '').toLowerCase(); return /double/.test(b) ? 'double' : /left/.test(b) ? 'left' : /right/.test(b) ? 'right' : 'centre'; }
  function swatch(st, i, isOn) {
    var o = st.o[i], na = o.v && !o.a;
    return '<button type="button" class="ws-vb__sw' + (isOn ? ' is-on' : '') + (na ? ' is-na' : '') + '" data-k="' + esc(st.k) + '" data-i="' + i + '"' + (na ? ' disabled' : '') + '>' +
      '<span class="ws-vb__swimg">' + (o.img ? '<img src="' + esc(o.img) + '" alt="" loading="lazy">' : '<span>' + esc(o.n.charAt(0)) + '</span>') + '</span>' +
      '<span class="ws-vb__swtxt">' + esc(o.n) + '</span>' + (o.v ? '<span class="ws-vb__swp">' + (na ? '<em>Sold out</em>' : priceTag(o, qtyFor(st))) + '</span>' : '') + '</button>';
  }
  function noneCard(st) {
    var on = S[st.k] === -1;
    return '<button type="button" class="ws-vb__sw ws-vb__sw--none' + (on ? ' is-on' : '') + '" data-k="' + esc(st.k) + '" data-i="-1"><span class="ws-vb__swimg"><span>&#8856;</span></span><span class="ws-vb__swtxt">' + esc(st.none) + '</span></button>';
  }
  var basinFilter = {};
  function renderBasin(st) {
    var tabs = [], models = [], byModel = {}, sel = S[st.k], f = basinFilter[st.k] || 'all';
    st.o.forEach(function (o, i) {
      if (!vis(st, i)) return;
      if (o.tab && tabs.indexOf(o.tab) < 0) tabs.push(o.tab);
      var key = o.tab + '|' + o.model;
      if (!byModel[key]) { byModel[key] = []; models.push(key); }
      byModel[key].push(i);
    });
    models.sort(function (a, b) { return a.split('|')[1].localeCompare(b.split('|')[1]); });
    var h = '';
    if (tabs.length > 1) h += '<div class="ws-vb__tabs">' + [['all', 'All']].concat(tabs.map(function (t) { return [t, t]; })).map(function (t) {
      return '<button type="button" class="ws-vb__tab' + (f === t[0] ? ' is-on' : '') + '" data-bf="' + esc(t[0]) + '" data-bk="' + esc(st.k) + '">' + esc(t[1]) + '</button>';
    }).join('') + '</div>';
    h += '<div class="ws-vb__basins">' + (st.none ? noneBasin(st) : '');
    var q = qtyFor(st);
    var shown = models.filter(function (key) { var first = st.o[byModel[key][0]]; return f === 'all' || first.tab === f; });
    var mkey = st.k + '|b|' + f, L = lim(true), open = OPEN[mkey];
    if (open == null) open = shown.slice(L).some(function (key) { return byModel[key].indexOf(sel) > -1; });
    var cut = shown.length > L + 1 && !open;
    shown.forEach(function (key, n) {
      if (cut && n >= L) return;
      var idxs = byModel[key], first = st.o[idxs[0]];
      var on = idxs.indexOf(sel) > -1, cur = on ? sel : idxs[0], o = st.o[cur];
      h += '<div class="ws-vb__basin' + (on ? ' is-on' : '') + '">' +
        '<button type="button" class="ws-vb__bimg" data-k="' + esc(st.k) + '" data-i="' + cur + '">' + (o.img ? '<img src="' + esc(o.img) + '" alt="" loading="lazy">' : '') + '</button>' +
        '<div class="ws-vb__binfo"><b>' + esc(o.model) + '</b>' + (o.tab ? '<small>' + esc(o.tab) + '</small>' : '') +
        '<span class="ws-vb__bprice">' + (o.v ? money(o.p * q) + (q > 1 ? ' <small>for ' + q + '</small>' : '') + (o.c > o.p ? ' <s>' + money(o.c * q) + '</s>' : '') : '') + '</span></div>' +
        (idxs.length > 1 || first.fin ? '<div class="ws-vb__fin">' + idxs.map(function (i) {
          var x = st.o[i], na = x.v && !x.a;
          return '<button type="button" class="ws-vb__finb' + (i === sel ? ' is-on' : '') + (na ? ' is-na' : '') + '" data-k="' + esc(st.k) + '" data-i="' + i + '"' + (na ? ' disabled title="Sold out"' : '') + '>' + esc(x.fin || x.model) + '</button>';
        }).join('') + '</div>' : '') + '</div>';
    });
    return h + '</div>' + (shown.length > L + 1 ? moreBtn(mkey, shown.length, open) : '');
  }
  function noneBasin(st) {
    var on = S[st.k] === -1;
    return '<div class="ws-vb__basin ws-vb__basin--none' + (on ? ' is-on' : '') + '"><button type="button" class="ws-vb__bimg" data-k="' + esc(st.k) + '" data-i="-1"><span>&#8856;</span></button><div class="ws-vb__binfo"><b>None</b><small>' + esc(st.none) + '</small></div></div>';
  }
  function renderStep(st, n) {
    var body = '';
    if (st.k === 'size') body = renderSize();
    else if (st.basin) body = (st.note ? '<p class="ws-vb__note">' + esc(st.note) + '</p>' : '') + renderBasin(st);
    else {
      var sel = S[st.k];
      if (st.note) body += '<p class="ws-vb__note">' + esc(st.note) + '</p>';
      var labelled = st.groups.length > 1 && st.groups.some(function (g) { return g.tab; });
      var nvis = st.o.filter(function (o, i) { return vis(st, i); }).length, big = nvis <= 8 && st.o.some(function (o) { return o.v; });
      if (st.sized && !selWidth()) body += '<p class="ws-vb__hint">Choose your size first to see the options that fit your ' + esc(root.dataset.noun || 'vanity') + '.</p>';
      // the whole step collapses to about three rows (across its groups) behind one "Show all" button
      var grs = [], all = 0, onAt = -1;
      st.groups.forEach(function (g, gi) {
        var idx = g.idx.filter(function (i) { return vis(st, i); });
        if (!idx.length) return;
        var cells = [];
        if (!grs.length && st.none && !st.multi) cells.push({ h: noneCard(st), on: sel === -1 });
        idx.forEach(function (i) { var on = st.multi ? (sel || []).indexOf(i) > -1 : sel === i; cells.push({ h: swatch(st, i, on), on: on }); });
        cells.forEach(function (c, n) { if (c.on && onAt < 0) onAt = all + n; });
        grs.push({ tab: g.tab, n: idx.length, cells: cells }); all += cells.length;
      });
      var L = lim(false), open = OPEN[st.k];
      if (open == null) open = onAt >= L; // a pick past the fold opens the list
      var cut = all > L + 2 && !open, left = cut ? L : all; // no button just to show one or two more
      grs.forEach(function (g) {
        if (left <= 0) return;
        var cs = g.cells.slice(0, left); left -= cs.length;
        if (labelled) body += '<div class="ws-vb__lbl">' + esc(g.tab || 'More options') + ' <small>(' + g.n + ')</small></div>';
        body += '<div class="ws-vb__sws' + (big ? ' ws-vb__sws--lg' : '') + '">' + cs.map(function (c) { return c.h; }).join('') + '</div>';
      });
      if (all > L + 2) body += moreBtn(st.k, all, open);
    }
    return '<div class="ws-vb__step' + (stepDone(st) && (st.req || S[st.k] != null) ? ' is-done' : '') + '" id="vb-' + esc(st.k) + '" data-step="' + esc(st.k) + '">' + stepHead(st, n) + '<div class="ws-vb__sb">' + body + '</div></div>';
  }
  function renderSteps() { stepsEl.innerHTML = liveSteps().map(function (st, i) { return renderStep(st, i + 1); }).join(''); }

  // ---- summary
  var sumEl = root.querySelector('[data-vb-sum]');
  function renderSum() {
    var m = mainSel(), ls = lines(), done = doneReq(), need = reqSteps().length, ok = done === need;
    var img = (m && m.img) || root.dataset.img;
    var h = '<div class="ws-vb__sumcard"><p class="ws-vb__sumh">Your design</p>' +
      '<div class="ws-vb__sumimg"><img src="' + esc(img) + '" alt=""></div>' +
      '<p class="ws-vb__sumt">' + esc(TITLE) + '</p><ul class="ws-vb__sumlist">';
    if (MAIN.length === 1 && m) h += '<li class="is-set"><span>Price</span><b>' + esc(m.t === 'Default Title' ? 'Vanity' : m.t) + '</b><em>' + money(m.p) + '</em></li>';
    liveSteps().forEach(function (st) {
      var t = summaryText(st);
      h += '<li class="' + (t ? 'is-set' : (st.req ? 'is-miss' : '')) + '"><span>' + esc(st.t) + '</span><b>' + (t ? esc(t) : (st.req ? 'Not chosen' : '—')) + '</b>';
      if (st.k === 'size') { var l = ls.filter(function (x) { return x.main; })[0]; if (l) h += '<em>' + money(l.p) + '</em>'; }
      else if (t) { var sm = ls.filter(function (y) { return y.step === st; }).reduce(function (a, y) { return a + y.p * y.q; }, 0); if (sm) h += '<em>+' + money(sm) + '</em>'; }
      h += '</li>';
    });
    var sv = savings();
    h += '</ul><div class="ws-vb__qty"><span>Quantity</span><div><button type="button" data-q="-1" aria-label="Less">&minus;</button><b>' + qty + '</b><button type="button" data-q="1" aria-label="More">+</button></div></div>' +
      '<div class="ws-vb__tot"><span>Total' + (sv ? '<small>You save ' + money(sv) + '</small>' : '') + '</span><b>' + (m ? money(total()) : '—') + '</b></div>' +
      '<p class="ws-vb__prog' + (ok ? ' is-ok' : '') + '">' + (ok ? '&#10003; All required steps done' : done + ' of ' + need + ' required steps done') + '</p>' +
      '<button type="button" class="ws-vb__add' + (ok ? '' : ' is-wait') + '" data-vb-add>' + (ok ? 'Add to cart' : 'Next: ' + esc(nextMissing().t)) + '</button>' +
      '<p class="ws-vb__err" data-vb-err hidden></p>' +
      '<button type="button" class="ws-vb__share" data-vb-share>Copy a link to this design</button>' +
      '<p class="ws-vb__fine">Made to order for you. Basins, wastes and upgrades are added as separate lines in your cart, grouped with this vanity.</p></div>';
    sumEl.innerHTML = h;
    root.querySelector('[data-vb-bar-total]').textContent = m ? money(total()) : 'Choose a size';
    root.querySelector('[data-vb-bar-prog]').textContent = ok ? 'Ready to add' : done + '/' + need + ' required steps';
    var bb = root.querySelector('.ws-vb__bar-btn'); bb.textContent = ok ? 'Add to cart' : 'Next step'; bb.classList.toggle('is-wait', !ok);
    var cp = card && card.querySelector('[data-vb-cardprog]');
    if (cp && (S.size && MAIN.length > 1 || done)) { cp.hidden = false; cp.innerHTML = '<b>' + done + ' of ' + need + '</b> required steps done' + (m ? ' · ' + money(total()) : ''); }
  }
  function nextMissing() { return reqSteps().filter(function (s) { return !stepDone(s); })[0] || steps[0]; }
  function rerender() { fixSized(); renderSteps(); renderSum(); saveHash(); }

  // ---- interactions
  function scrollToStep(k, flash) {
    var el = document.getElementById('vb-' + k); if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - 110;
    window.scrollTo({ top: y, behavior: 'smooth' });
    if (flash) { el.classList.remove('is-flash'); void el.offsetWidth; el.classList.add('is-flash'); }
  }
  function afterPick(k) {
    var ls_ = liveSteps(), i = ls_.findIndex(function (s) { return s.k === k; }), nx = ls_[i + 1];
    if (!nx) return;
    var el = document.getElementById('vb-' + nx.k); if (!el) return;
    if (el.getBoundingClientRect().top > window.innerHeight * 0.75) setTimeout(function () { scrollToStep(nx.k); }, 150);
  }
  root.addEventListener('click', function (e) {
    var t = e.target;
    var w = t.closest('[data-w]');
    if (w) { selW = w.getAttribute('data-w'); var opts = MAIN.filter(function (m) { return m.w === selW && m.a; }); if (opts.length === 1) S.size = opts[0].id; else if (mainSel() && mainSel().w !== selW) S.size = null; rerender(); if (S.size) afterPick('size'); return; }
    var sz = t.closest('[data-size]');
    if (sz) { S.size = +sz.getAttribute('data-size'); rerender(); afterPick('size'); return; }
    var mo = t.closest('[data-more]');
    if (mo) { var mk = mo.getAttribute('data-more'), stp = mo.closest('.ws-vb__step'); OPEN[mk] = !(mo.textContent.indexOf('Show fewer') === 0); rerender(); if (!OPEN[mk] && stp) { var el = document.getElementById(stp.id); if (el && el.getBoundingClientRect().top < 0) scrollToStep(stp.getAttribute('data-step')); } return; }
    var bf = t.closest('[data-bf]');
    if (bf) { basinFilter[bf.getAttribute('data-bk')] = bf.getAttribute('data-bf'); rerender(); return; }
    var sw = t.closest('[data-k]');
    if (sw && !sw.disabled) {
      var k = sw.getAttribute('data-k'), i = +sw.getAttribute('data-i'), st = stepBy(k); if (!st) return;
      if (st.multi) { var a = (S[k] || []).slice(), p = a.indexOf(i); if (p > -1) a.splice(p, 1); else a.push(i); S[k] = a; rerender(); return; }
      S[k] = i; rerender(); afterPick(k); return;
    }
    var q = t.closest('[data-q]');
    if (q) { qty = Math.max(1, Math.min(20, qty + (+q.getAttribute('data-q')))); renderSum(); return; }
    if (t.closest('[data-vb-share]')) { saveHash(); try { navigator.clipboard.writeText(location.href); t.closest('[data-vb-share]').textContent = 'Link copied ✓'; } catch (x) {} return; }
    if (t.closest('[data-vb-add]')) { add(); return; }
  });
  if (card) card.addEventListener('click', function (e) { if (e.target.closest('[data-vb-start]')) { e.preventDefault(); scrollToStep(stepDone(steps[0]) ? nextMissing().k : steps[0].k); } });

  // ---- share / restore (#vb=size.123|adp-cabinet-colour.4|...)
  function saveHash() {
    var parts = [];
    Object.keys(S).forEach(function (k) { var v = S[k]; if (v == null || (Array.isArray(v) && !v.length)) return; if (k === 'size' && MAIN.length === 1) return; parts.push(k + '.' + (Array.isArray(v) ? v.join('_') : v)); });
    var h = parts.length ? '#vb=' + parts.join('|') : '';
    try { history.replaceState(null, '', location.pathname + location.search + h); } catch (e) {}
  }
  function loadHash() {
    var m = /[#&]vb=([^&]+)/.exec(location.hash); if (!m) return;
    decodeURIComponent(m[1]).split('|').forEach(function (p) {
      var d = p.lastIndexOf('.'), k = p.slice(0, d), v = p.slice(d + 1);
      if (k === 'size') { var mm = MAIN.filter(function (x) { return x.id === +v; })[0]; if (mm) { S.size = mm.id; selW = mm.w; } return; }
      var st = stepBy(k); if (!st) return;
      var ok = function (i) { return i === -1 ? !!st.none : !!st.o[i] && !(st.o[i].v && !st.o[i].a); };
      if (st.multi) S[k] = v.split('_').map(Number).filter(function (i) { return i >= 0 && ok(i); });
      else if (ok(+v)) S[k] = +v;
    });
  }

  // ---- add to cart
  // builds the /cart/add.js items for the current design (or returns an error message)
  function payload() {
    var m = mainSel(), ls = lines(), build = 'B' + Date.now().toString(36);
    if (!m) return { err: 'Please choose a size.' };
    var props = { '_ws_build': build, '_io_order_group': build };
    fixSized();
    liveSteps().forEach(function (st) { if (st.k === 'size') return; var t = summaryText(st); if (t) props[st.p || st.t] = t + (st.bowls && bowls() > 1 && S[st.k] > -1 ? ' (x' + bowls() + ')' : ''); });
    var unavailable = ls.filter(function (l) { return l.vid && l.a === false; });
    if (unavailable.length) return { err: unavailable[0].sub + ' is currently unavailable. Please choose another option.' };
    var forLabel = TITLE + (MAIN.length > 1 ? ' (' + m.t + ')' : '');
    var items = [];
    ls.forEach(function (l) {
      if (l.main || !l.vid) return;
      items.push({ id: +l.vid, quantity: l.q * qty, properties: { 'For': forLabel, '_ws_build': build, '_io_parent_order_group': build } });
    });
    items.push({ id: m.id, quantity: qty, properties: props });
    return { items: items };
  }
  var busy = false;
  function add() {
    if (busy) return;
    var miss = reqSteps().filter(function (s) { return !stepDone(s); })[0];
    if (miss) { scrollToStep(miss.k, true); return; }
    var pl = payload(); if (pl.err) { showErr(pl.err); return; }
    var items = pl.items;
    var btns = root.querySelectorAll('[data-vb-add], .ws-vb__bar-btn');
    busy = true;
    btns.forEach(function (b) { b.disabled = true; b.classList.add('is-busy'); });
    showErr('');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { showErr(res.j.description || res.j.message || 'Sorry, something went wrong adding this to your cart.'); return; }
        if (!window.WSCart) { location.href = '/cart'; return; }
        setTimeout(function () { if (window.WSCart) { window.WSCart.refresh(); window.WSCart.open(); } }, 300);
      })
      .catch(function () { showErr('Sorry, something went wrong. Please try again.'); })
      .then(function () { busy = false; btns.forEach(function (b) { b.disabled = false; b.classList.remove('is-busy'); }); });
  }
  function showErr(msg) { var e = root.querySelector('[data-vb-err]'); if (!e) return; e.textContent = msg; e.hidden = !msg; }
  // test hook: inspect the design and its cart payload without adding anything
  window.WSBuilder = { state: S, steps: steps, lines: lines, total: total, payload: payload, live: liveSteps, vis: vis };

  // (the bottom-bar button carries data-vb-add, so the root click handler above covers it)
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { root.classList.toggle('is-inview', en[0].isIntersecting); }, { rootMargin: '-30% 0px -10% 0px' }).observe(root.querySelector('.ws-vb__grid'));
  }

  var lastLim = lim(false);
  window.addEventListener('resize', function () { var l = lim(false); if (l !== lastLim) { lastLim = l; renderSteps(); } });

  loadHash();
  if (!S.size && MAIN.length === 1) { S.size = MAIN[0].id; selW = MAIN[0].w; }
  rerender();
})();
